import DatePicker from './DatePicker'
import RangeDatePicker from './RangeDatePicker'
import moment from 'moment'

import { getParseLocale } from '../../utils/browserLocale'

moment.locale(getParseLocale())

export { DatePicker, RangeDatePicker }
